import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-esecuzione-view',
  templateUrl: './form-esecuzione-view.component.html',
  styleUrls: ['./form-esecuzione-view.component.css']
})
export class FormEsecuzioneViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
